import { DDR3, DDR3L, NVDDR3, DDR4, LPDDR4, DDR5, LPDDR5, DDR5_RDIMM, DDR5_SODIMM, DDR5_UDIMM, DDR5_RDIMM_CARD, DDR5_SODIMM_CARD, DDR5_UDIMM_CARD, DDR5_RDIMM_X4 } from '../constants';
import permissionData from '@/services/helper/data/permissionData';
import { D2D_CHANNEL, PACKAGE, CARD } from '../../../constants/treeConstants'
import { getPowerVoltage } from './setupData';
import { SIWAVE, HFSS, POWERSI, SIWAVE_HFSS } from '../../../constants/extractionType';
import { PROJECT_V2 } from '../../../constants/projectVersion';

export function Extraction(ddrType, designType, projectVersion) {
  //version 0.0.3
  this.clipping = true;
  this.clipSize = "0.3"; //float >= 0.1, unit: ratio
  this.includeDC = false; //true/false
  this.exactDC = false; //true/false
  this.discreteSweep = false; //true/false
  this.meshFrequency = "5"; //float >1
  this.maxPasses = "10"; // only show if modeling with HFSS
  this.maxDelta = "0.02"; //float [0.001,1] only show if modeling with HFSS
  this.portLimit = "150"; // V0.0.3 new field [30,300] must be integer
  this.portImpedance = "50";
  this.siwave = {} //yml file -> siwaveOptionLibraryId
  this.hfss = {} //yml file -> hfssOptionLibraryId
  this.errorTolerance = '0.005'; //float [0.0005,0.05] SIwave/HFSS

  // Byte sweep config
  this.logSweepMin = "1000";
  this.logSweepMax = "1e7";
  this.logSweepSAPD = "10";
  this.linearSweepMax = "5e9";
  this.linearSweepFreqStep = "5e6";
  this.maxFreq = ddrType ? getMaxFreqByDDRType(ddrType, false) : "";

  // CA sweep config
  if (projectVersion !== PROJECT_V2) {
    this.caLogSweepMin = "1000";
    this.caLogSweepMax = "1e7";
    this.caLogSweepSAPD = "10";
    this.caLinearSweepMax = "5e9";
    this.caLinearSweepFreqStep = "5e6";
    this.caMaxFreq = ddrType ? getMaxFreqByDDRType(ddrType, true) : "";
  }

  if (designType === PACKAGE) {
    // package
    const type = permissionData.getRockyExtraction();
    this.type = type === "Default" ? "SIwave" : type;
    this.backdrillVias = false;
  } else {
    this.backdrillVias = false;
    this.backdrillStubSize = "8mil";// [1, 50],unit mil
  }

  if (projectVersion !== PROJECT_V2) {
    this.SAPD = "100";
    this.FMAX = "2e8";
    this.REFR = "0.1";
    this.vrFswSwitch = false;
    this.numCores = "4";
    this.corePercent = "50";
    this.CLIP = "1";
    this.pwsiMaxPadSize = "";
    this.pwsiMinShapeSize = "";
    this.pwsiDogleg = "1.5";
    this.pwsiThermal = "1.5";
    this.pwsiHole = "1.5";
    this.pwsiViaHole = "1.5";
    // this.pwsiSlenderHoleSize = "1";
    this.pwsiAutoSpecialVoidSetting = false;
    this.ratio = "0.3";
    this.bottomFloating = false;
    this.bottomDistance = "0.01";
    this.topFloating = false;
    this.topDistance = "0.01";
    this.pwsiSlenderHoleAreaThreshold = "0";
    this.pwsiSlenderHoleSizeThreshold = "0";
  }
};

// SYS
//   verification Extraction  ExtractionPanel.js
//       SIwave/HFSS/powersi/Build in
//   card verification Extraction  cardExtractionPanel.js
//       SIwave/HFSS
//   package verification Extraction  extractionComponents.js
// SEV
//   pcb channel Extraction  ExtractionPanel
//       SIwave/HFSS
//   pcb pdn Extraction  PkgExtractionPanel
//   package channel Extraction  extractionComponents　和sys package extraction一样
//   package pdn Extraction  PkgExtractionPanel
export function newExtractionInfo({ config = {}, type, ddrType, pageType, noDistinctionByteCA, isNew, clipSizeUnit }) {
  const { clipping, clipSize,
    backdrillVias, backdrillStubSize, q3dRegions,
    includeDC, exactDC,/* portImpedance, discreteSweep,*/
    logSweepMin, logSweepMax, logSweepSAPD, linearSweepMax, linearSweepFreqStep, maxFreq,
    caLogSweepMin, caLogSweepMax, caLogSweepSAPD, caLinearSweepMax, caLinearSweepFreqStep, caMaxFreq,
    meshFrequency, maxPasses, maxDelta, portLimit, hpc_options,
    siwave, hfss, timeout, isSamePCB, isSameSweep,
    // powersi
    pwsiMaxPadSize, pwsiMinShapeSize, pwsiDogleg, pwsiThermal,
    pwsiHole, pwsiViaHole, numCores, corePercent,
    topFloating, topDistance,
    bottomFloating, bottomDistance,
    pwsiSlenderHoleAreaThreshold, pwsiSlenderHoleSizeThreshold, pwsiAutoSpecialVoidSetting,
    hybrid
  } = config;
  let newType = type === SIWAVE_HFSS ? SIWAVE : type;

  this.includeDC = includeDC || false; //true/false

  // this.portImpedance = portImpedance || "50"//not used
  // this.discreteSweep = discreteSweep || false; //only sev pdn

  // Byte sweep config
  this.logSweepMin = logSweepMin || "1000";
  this.logSweepMax = logSweepMax || "1e7";
  this.logSweepSAPD = logSweepSAPD || "10";
  this.linearSweepMax = linearSweepMax ? linearSweepMax : pageType === D2D_CHANNEL ? "2e10" : "5e9";
  this.linearSweepFreqStep = linearSweepFreqStep || "5e6";
  this.maxFreq = maxFreq || !isNew ? maxFreq : ddrType ? getMaxFreqByDDRType(ddrType, false) : "";

  // CA Sweep config
  if (!noDistinctionByteCA && pageType !== D2D_CHANNEL) {
    this.caLogSweepMin = caLogSweepMin || "1000";
    this.caLogSweepMax = caLogSweepMax || "1e7";
    this.caLogSweepSAPD = caLogSweepSAPD || "10";
    this.caLinearSweepMax = caLinearSweepMax || "5e9";
    this.caLinearSweepFreqStep = caLinearSweepFreqStep || "5e6";
    this.caMaxFreq = caMaxFreq || !isNew ? caMaxFreq : ddrType ? getMaxFreqByDDRType(ddrType, true) : "";
  }

  if ([PACKAGE, D2D_CHANNEL].includes(pageType)) {
    const _type = type ? type : permissionData.getRockyExtraction();
    newType = _type === "Default" ? "SIwave" : _type;
    this.type = newType;
    if (pageType === PACKAGE) {
      this.isSamePCB = isNew ? true : isSamePCB || false;
      this.isSameSweep = isNew ? true : isSameSweep || false;
    }
  } else {
    if (pageType !== CARD) {
      // this.backdrillVias = backdrillVias || false;
      this.backdrillVias = typeof (backdrillVias) !== "boolean" ? false : backdrillVias;
      this.backdrillStubSize = backdrillStubSize || "8mil";
    }
  }


  if ([SIWAVE, HFSS].includes(newType)) {
    this.clipping = clipping || false;
    this.clipSize = clipSize || "0.3"; //float >= 0.1, unit: ratio

    this.exactDC = exactDC || false; //true/false

    this.meshFrequency = meshFrequency || "5"; //float >1
    this.maxPasses = maxPasses || "10"; // only show if modeling with HFSS
    this.maxDelta = maxDelta || "0.02"; //float [0.001,1] only show if modeling with HFSS
    this.portLimit = portLimit || "150"; // V0.0.3 new field [30,300] must be integer

    if (config.hasOwnProperty("hpc_options")) {
      this.hpc_options = hpc_options && Object.keys(hpc_options) ? hpc_options : new HPCOptions()
    }

    if (config.hasOwnProperty("timeout")) {
      this.timeout = timeout
    }
  }

  if (newType === SIWAVE) {
    this.siwave = siwave || {}; //yml file -> siwaveOptionLibraryId
    this.q3dRegions = q3dRegions || false;
    this.hybrid = pageType === PACKAGE ? false : hybrid || false;
    if (hybrid) {
      this.hfss = hfss || {}; //yml file -> hfssOptionLibraryId
    }
  }

  if (newType === HFSS) {
    this.hfss = hfss || {} //yml file -> hfssOptionLibraryId
  }

  if (newType === POWERSI) {
    // Only available in sev package/pcb pdn, see PackageExtraction method for pdn initialization
    // this.SAPD = "100";
    // this.FMAX = "2e8";
    // this.REFR = "0.1";
    // this.vrFswSwitch = false;
    // this.CLIP = "1";

    this.pwsiMaxPadSize = pwsiMaxPadSize === "-1" ? "" : pwsiMaxPadSize || "";
    this.pwsiMinShapeSize = pwsiMinShapeSize === "-1" ? "" : pwsiMinShapeSize || "";

    this.pwsiDogleg = pwsiDogleg || "1.5";
    this.pwsiThermal = pwsiThermal || "1.5";
    this.pwsiHole = pwsiHole || "1.5";
    this.pwsiViaHole = pwsiViaHole || "1.5";

    this.numCores = numCores || "4";
    this.corePercent = corePercent || "50";

    this.topFloating = topFloating || false;
    this.topDistance = topDistance || "0.01";

    this.bottomFloating = bottomFloating || false;
    this.bottomDistance = bottomDistance || "0.01";

    this.pwsiSlenderHoleAreaThreshold = pwsiSlenderHoleAreaThreshold || "0";
    this.pwsiSlenderHoleSizeThreshold = pwsiSlenderHoleSizeThreshold || "0";

    this.pwsiAutoSpecialVoidSetting = pwsiAutoSpecialVoidSetting || false;

    // this.ratio = "0.3";not used
    // this.createModelByPartNumber = true;//The front-end code has been commented out. don't know if it is used in the back-end.
  }

  if (type === SIWAVE_HFSS) {
    this.clipSize = clipSizeUnit === 'ratio' ? "3" : clipSize;
    this.clipping = true;
  }
}

export function HPCOptions() {
  this.num_tasks = "1";
  this.num_cores = "4";
  this.num_gpus = "0";
  this.ram_percent = "90";
}

// For DDR3 – those two tables should be exactly the same default, Fmax = 5GHz.
// For DDR4 and LPDDR4 – the Fmax for CA is 5GHz while the Fmax for Byte is 10GHz.
// For DDR5 – the Fmax for CA is 10GHz while the Fmax for Byte is 20GHz.
// For LPDDR5 – the Fmax for CA is 5GHz while the Fmax for Byte is 20GHz.
function getMaxFreqByDDRType(type, isCA) {
  switch (type) {
    case DDR4:
    case LPDDR4:
      return isCA ? "" : "1e10";
    case DDR5:
    case DDR5_RDIMM:
    case DDR5_SODIMM:
    case DDR5_UDIMM:
    case DDR5_RDIMM_CARD:
    case DDR5_SODIMM_CARD:
    case DDR5_UDIMM_CARD:
    case DDR5_RDIMM_X4:
      return isCA ? "1e10" : "2e10";
    case LPDDR5:
      return isCA ? "" : "2e10";
    case DDR3:
    case DDR3L:
    case NVDDR3:
    default: return ""; // 5GHz
  }
}

const byteSweep = ['logSweepMin', 'logSweepMax', 'logSweepSAPD', 'linearSweepMax', 'linearSweepFreqStep', 'maxFreq'];
const caSweep = ['caLogSweepMin', 'caLogSweepMax', 'caLogSweepSAPD', 'caLinearSweepMax', 'caLinearSweepFreqStep', 'caMaxFreq'];
export function judgeExtraction(extraction, ddrType = "") {
  if (Object.keys(extraction).length >= 22) {
    return extraction;
  }

  let newExtraction = { ...extraction };
  for (let i = 0; i < caSweep.length; i++) {
    if (newExtraction[caSweep[i]] === undefined) {
      newExtraction[caSweep[i]] = newExtraction[byteSweep[i]];
    }
  }
  return newExtraction;
}

export function PDNExtraction() {
  this.CLIP = 1;//default 1
  this.IPC = 1; //default 1
  this.VRTC = "1"; //default 1 float range=[0, 10]
  this.VOID = "1e-6";//range=[0, 10], default=2.0
  this.PLNM = "1e-6";//range=[0, 1e-4], default=1e-6
  this.PADM = "1e-6";//range=[0, 5], default=1e-6
  this.DISC = 0;//default=0
  this.DC = 1;//default=1
  this.FMAX = '200e6';//Range=[0, 2e9], default=200e6
  this.SAPD = "100";//range=[1, 200], default=100
  this.SIWE = 0;//default=0
  this.REFR = '0.1';//range=[0, 1000], default=0.1
  this.UPDC = 0; //default false
}

export function pdnPKG() {
  this.type = "value"; //value / Touchstone / SPICE
  this.r = "0.01";
  this.l = "50p";
  this.c = "500p";
  this.model = {
    fileName: "",
    libraryId: "",
    subckt: "",
    pairs: [] // [ { pin:"", node:"" } ]
  };
}

export function pdnDie() {
  this.type = "value";//value / Touchstone / SPICE
  this.r = "0.1";
  this.c = "10n";
  this.model = {};
}

export class RockyInterface {
  constructor(name = '') {
    this.Name = name; // interface name
    this.Signals = []; // [Signal]
    this.Components = []; // [RLCCONComponent,ICComponent]
    this.PowerNets = []; // [SourceNets]
    this.Channel = {};//{channel}
    this.PowerComponents = []; // [{ id, name, pins, type, value }]
    this.Ports_generate_setup_list = [];
    this.ReferenceNets = [];
    this.Port_setups = [];
  }
}

export class RockyPackageInterface {
  constructor() {
    this.Signals = []; // [Signal]
    this.Components = [];
    this.PowerNets = [];
    this.Ports_generate_setup_list = [];
    this.ReferenceNets = [];
    this.Port_setups = [];
  }
}

export class BasicComponent {
  constructor({ name = '', type = '', pins = [], usage = '', part = "" }) {
    this.name = name;
    this.pins = pins;
    this.part = part;
    if (!usage) {
      this.type = type;
    }
    this.addModel.bind(this);
  }

  addModel({ signal, pin, net }) {
    this.pins.push(new BasicCompModel({ signal, pin, net }));
  }
}

export class BasicCompModel {
  constructor({ signal, pin, net, haveCorner }) {
    this.signal = signal || '';
    this.pin = pin || '';
    this.net = net || '';
    if (haveCorner) {
      this.corner = "typ";
    }
    this.usage = '';
  }
}

// ================= Component structure =================
// RLC,connector component
export class RLCCONComponent extends BasicComponent {
  constructor(props) {
    super(props);
    this.value = props.value || '';
    if (props.usage) {
      this.usage = props.usage || '';
      this.COMP_TYPE = props.usage;
    }
  }
}

// Driver,receiver(IC) component
export class ICComponent extends BasicComponent {
  constructor(props) {
    super(props);
    this.deviceVcc = "";
    this.corner = 'typ';
    this.usage = props.usage || '';
  }
}

// ================== Signal structure ===================
export class Signal {
  constructor(name = '') {
    this.name = name;
    this.nets = [];
  }
}

// ================= SourceNets structure ================
export class SourceNets {
  constructor(name = '', value = '') {
    this.name = name;
    this.value = value;
  }
}

// ============== Component Model structure ==============
// Receiver model
export class ICCompModel extends BasicCompModel {
  constructor(props) {
    super(props);
    this.usage = ""; // Receiver|Driver|Ignore
    this.model = {}; // model object
    this.powerOff = ""; // POWER ON/POWER OFF - false|true
    this.pinModels = [];
  }
}

// ================= PinModel structure ==================
export class PinModel {
  constructor({ pinName }) {
    this.pinName = pinName;
    this.stimulus = {}; // stimulus / object {new Stimulus()}
    this.voltage = "";
    this.type = ""; // CLK|SDR|DDR|GND|VCC|VEC(stimulus) - Driver nd_in/nd_en pin
  }
}

// =================== Model structure ===================
export class Model {
  constructor({ modelType = '', enableVoltage = '', modelName = '', fileName = '', libType = '', libraryId = "", folder = "", isAmi = false }) {
    this.modelType = modelType;
    this.enableVoltage = enableVoltage;
    this.modelName = modelName;
    this.fileName = fileName;
    this.libType = libType; // IBIS SPICE IBIS_AMI
    this.libraryId = libraryId;
    this.folder = folder;
    this.isAmi = isAmi
  }
}

export class Stimulus {
  constructor() {
    this.name = "";
    this.delay = "";
    this.riseTime = "";
    this.fallTime = "";
    this.period = "1000"
    this.pattern = "";
    this.voltage = "";
    this.timeUnit = "ns";
  }
}

export class Channel {
  constructor(type = 'Default') {
    this.type = type; // SIwave|HFSS|Default
  }
}

// ==== Driver pin ===
export class Driver {
  constructor({ powerOff = "", pinModels = [], model = {}, jitter = {}, dutyCycle = {}, amiParams, ads, adsStimulus }) {
    this.model = model || {} // model object
    this.powerOff = powerOff || ""; // POWER ON/POWER OFF - 0|1
    this.pinModels = pinModels || [];

    if (jitter && Object.keys(jitter).length) {
      this.jitter = jitter
    }
    if (dutyCycle && dutyCycle.DCD) {
      this.dutyCycle = dutyCycle
    }
    if (amiParams) {
      this.amiParams = amiParams
    }
    if (ads) {
      this.ads = ads;
    }
    if (adsStimulus) {
      this.adsStimulus = adsStimulus;
    }
  }
}

// ==== Receiver pin ===
export class Receiver {
  constructor({ powerOff = "", model = {}, amiParams, pinModels = [], ads }) {
    this.model = model; // model object
    this.powerOff = powerOff || "0";
    this.pinModels = pinModels || [];
    if (amiParams) {
      this.amiParams = amiParams
    }
    if (ads) {
      this.ads = ads;
    }
  }
}

// ==== Default Config (simulation options) ====
export function ConfigInfo({
  clock = '800M',
  cycles = '200',
  cmd_2t_mode = false,
  timeStep = '15p',
  corners = [],
  ngspiceMDFLM = '30ps',
  simulate = permissionData.getRockySimulator(),
  caClock,
  caTimeStep,
  hspiceCores = 2,
  isSev = false,
  hspiceLicenses = 2,
  simulateMode = "Transient",
  statEyeConfig,
  notStateConfig,
  pdnWorstScenario = false,
  pdnResonanceFreq = "123M",
  pdaIsiWorstPattern = false,
  enableSElement = false,
  method = 'trap',
  nImpulse = "2",
  adsConfig,
  advancedOptions,
  terminateOption,
  enableLinkEcc,
  compliance,
  usageCompGroupApply,
  usageOppositeDirApply
}) {
  this.clock = clock;
  this.cycles = cycles;
  this.timeStep = timeStep;
  /* this.xTalk = "1"; */
  this.simulate = simulate;
  if (corners && corners.length) {
    this.corners = corners;
  }
  this.cmd_2t_mode = cmd_2t_mode;
  this.ngspiceMDFLM = ngspiceMDFLM;
  if (caClock) {
    this.caClock = caClock;
  }
  if (caTimeStep) {
    this.caTimeStep = caTimeStep;
  }
  if (isSev) {
    this.hspiceLicenses = hspiceLicenses
  } else {
    this.hspiceCores = hspiceCores;
  }
  if (simulateMode) {
    this.simulateMode = simulateMode;
  }
  if (simulateMode === 'StatEye') {
    this.statEyeConfig = statEyeConfig;
  } else if (!notStateConfig) {
    this.statEyeConfig = {
      transientEngine: '',
      simulationMode: '',
      edgesNum: '',
      crosstalkType: '',
      eyeDiagramTriggering: '',
      eyeDiagramTriggeringClockMode: '',
      numberBits: '',
      nImpulse: '',
    };
  }
  this.enableSElement = enableSElement
  if (pdnWorstScenario) {
    this.pdnWorstScenario = pdnWorstScenario;
  }
  if (pdnResonanceFreq) {
    this.pdnResonanceFreq = pdnResonanceFreq;
  }
  if (pdaIsiWorstPattern) {
    this.pdaIsiWorstPattern = pdaIsiWorstPattern;
  }
  if (method) {
    this.method = method; // trap | gear
  }
  if (adsConfig) {
    this.adsConfig = adsConfig;
  }
  this.advancedOptions = advancedOptions || [];
  this.terminateOption = terminateOption || { enableTerminate: false, terminateValue: 50 };
  this.enableLinkEcc = enableLinkEcc || false;
  if (compliance) {
    this.compliance = compliance;
  }
  if (usageCompGroupApply !== undefined) {
    this.usageCompGroupApply = usageCompGroupApply;
  }
  if (usageOppositeDirApply !== undefined) {
    this.usageOppositeDirApply = usageOppositeDirApply;
  }
}
/* 
export class PackageModelInfo {
  constructor(type = '') {
    this.type = type;
    this.files = [{
      type: type,
      fileName: "",
      libraryId: "",
      subckt: ""
    }]
    this.subckt = '';
    this.pairs = [];
  }
} */
export class PackageModelInfo {
  constructor(type = '') {
    this.type = type;
    this.files = []; //{ type, fileName, libraryId, subckt }
    this.pairs = []; // [ { pin, node, subckt, libraryId } ,{ pin, node, subckt, libraryId }, ... ]
    this.rank = null;
  }
}

export class PackageModelFileInfo {
  constructor() {
    this.type = "";
    this.fileName = "";
    this.libraryId = "";
    this.subckt = "";
    this.modelKey = "";
  }
}

export class WaveformConfig {
  constructor({ ddrType, isPrevCase }) {
    this.crosstalkRiseTime = isPrevCase ? "25ps" : "0.1";//unit ratio
    this.crosstalkFallTime = isPrevCase ? "25ps" : "0.1";//unit ratio
    this.voltagePulse = isPrevCase ? "1" : getPowerVoltage(ddrType);//unit V
  }
}

export class PinSpiceModel {
  constructor({ fileName = '', libType = '', libraryId = "", folder = "", modelName = "", node = null }) {
    this.fileName = fileName || "";
    this.libType = libType; // SPICE
    this.libraryId = libraryId;
    this.folder = folder || "";
    this.modelName = modelName || "";
    this.node = node || { in: "", out: "" }
  }
}

export function getExtractionTimeout(timeout) {
  const hours = Math.floor(timeout / 60);
  const minutes = timeout % 60;
  return { hours, minutes }
}